/**
 * API may return `ready` for a healthy workspace; UI shows the same label as `active`.
 *
 * @param {string | null | undefined} status
 * @param {(key: string) => string} t — `t` from useTranslation('workspaces')
 */
export const formatWorkspaceStatusLabel = (status, t) => {
  const raw = status?.trim() ?? '';
  if (!raw) return '';
  const k = raw.toLowerCase();
  if (k === 'ready' || k === 'active' || k === 'enabled') return t('list.card.statusActive');
  return raw;
};

/** Green / success styling — includes `ready` (treated like active). */
export const isWorkspaceStatusActive = (status) => {
  const k = status?.toLowerCase() ?? '';
  return k === 'active' || k === 'enabled' || k === 'ready';
};
